var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPlane = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 30,
  height: 24,
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M27.276.266 2.158 9.95c-1.714.689-1.704 1.645-.314 2.072l6.448 2.011 14.92-9.413c.706-.43 1.35-.199.82.272l-12.088 10.91h-.003.003l-.445 6.648c.652 0 .94-.3 1.305-.652l3.133-3.046 6.515 4.813c1.201.661 2.064.321 2.363-1.113l4.277-20.156c.437-1.755-.67-2.55-1.816-2.031Z"
})));
export { SvgPlane as ReactComponent };
export default __webpack_public_path__ + "41a8c2d575aaaa79cef4a47011412235.svg";